import React from 'react';
import ExpenseProposalWorkspace from './ExpenseProposalWorkspace';

/** 지출품의등록 */
export default function ExpenseProposalRegister() {
  return <ExpenseProposalWorkspace screenMode="register" />;
}
